import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const BookingSection = () => {
  useEffect(() => {
    if (window.location.hash === '#book') {
      document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Box
      id="book"
      sx={{
        py: { xs: 8, md: 10 },
        px: 3,
        bgcolor: 'var(--color-cream)',
      }}
    >
      <Box sx={{ maxWidth: 520, mx: 'auto', textAlign: 'center' }}>
        <Typography
          variant="overline"
          sx={{ letterSpacing: 3, color: 'var(--color-warm-gray)', fontWeight: 500, fontSize: '0.85rem' }}
        >
          Stay with us
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: { xs: '2.25rem', md: '3rem' },
            fontWeight: 500,
            mt: 1,
            mb: 3,
            color: 'var(--color-charcoal)',
          }}
        >
          Request a reservation
        </Typography>
        <Typography sx={{ color: 'var(--color-warm-gray)', mb: 4 }}>
          View room availability and request a reservation.
        </Typography>
        <Button
          component={Link}
          to="/book"
          variant="contained"
          size="large"
          sx={{
            py: 1.5,
            px: 3,
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2,
            bgcolor: 'var(--color-accent)',
            '&:hover': { bgcolor: 'var(--color-accent-light)' },
          }}
        >
          Book
        </Button>
      </Box>
    </Box>
  );
};

export default BookingSection;
